import styles from './Assignment.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

interface AssignmentItem {
  title: string
  text: string
}

interface Props {
  list: AssignmentItem[]
}

const Assignment: React.FC<Props> = ({ list }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.assignment} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>解決できる課題</h2>
      <ul className={styles.assignmentList}>
        {list.map((item, index) => (
          <li key={index} className={styles.assignmentList__item}>
            <h3 className={styles.assignmentList__item__title}>{item.title}</h3>
            <p className={styles.assignmentList__item__text}>{item.text}</p>
          </li>
        ))}
      </ul>
    </section>
  )
}

export default Assignment
